import { FC } from 'react';
import styles from './RecentItems.module.scss';

export interface RecentItem {
  id: string;
  badge: string;
  title: string;
  timestamp: string;
  href: string;
}

const DEFAULT_RECENT_ITEMS: RecentItem[] = [
  {
    id: 'ahu-001',
    badge: 'PDF',
    title: 'AHU-001 O&M Manual',
    timestamp: '2 hours ago',
    href: '/more-info',
  },
  {
    id: 'lv-schematic',
    badge: 'E',
    title: 'LV schematic LV01',
    timestamp: 'Yesterday',
    href: '/more-info',
  },
];

export const RecentItems: FC = () => {
  return (
    <section className={styles.container} aria-labelledby="recent-heading">
      <div className={styles.header}>
        <h3 id="recent-heading" className={styles.title}>
          Recently viewed
        </h3>
        <p className={styles.subtitle}>Pick up where you left off.</p>
      </div>

      <ul className={styles.list}>
        {DEFAULT_RECENT_ITEMS.map((item) => (
          <li key={item.id}>
            <a href={item.href} className={styles.item}>
              <div className={styles.badge} aria-label={`Format: ${item.badge}`}>
                {item.badge}
              </div>
              <div className={styles.itemContent}>
                <span className={styles.itemTitle}>{item.title}</span>
                <span className={styles.itemTimestamp}>{item.timestamp}</span>
              </div>
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
};
